import { PAGES as PAGES_TYPE } from "@/data/types/pages";

export const PAGES = Object.fromEntries(Object.entries(PAGES_TYPE) as any[]) as {
  [key in keyof typeof PAGES_TYPE]: string;
} & { [x: string]: string };
